export const isBusinessReviewPath = (pathname: string, base: string) =>
  pathname === base || (pathname.startsWith(`${base}/`) && /^[^/]+$/.test(pathname.slice(base.length + 1)));
